<template>
  <v-app>
    <v-navigation-drawer 
      v-if="user && user.profile"
      v-model="drawer"
      expand-on-hover
      permanent 
      class="no-print" 
      app>
      <v-list dense>
        <v-list-item>
          <v-list-item-avatar v-if="profilePhoto">
            <v-img :src="profilePhoto" />
          </v-list-item-avatar>
          <v-list-item-title v-text="myName"></v-list-item-title>
        </v-list-item>
        <v-divider></v-divider>
        <v-list-item v-if="me && me.person && (me.person.isEditor || me.person.isValidator)" @click.stop="title = 'Dashboard'" to="/">
          <v-list-item-icon>
            <v-icon>dashboard</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Dashboard</v-list-item-title>
        </v-list-item>
        <v-list-group v-if="isTechnicalAdmin || (me && me.person && (me.person.isUserAdmin || me.person.isOrganizationAdmin))" no-action prepend-icon="mdi-ship-wheel">
          <v-list-item slot="activator">
            <v-list-item-title>Administration</v-list-item-title>
          </v-list-item>
          <v-list-item @click.stop="title = 'Organizations'" to="/administration/organizations">
            <v-list-item-title>Organizations</v-list-item-title>
            <v-list-item-icon>
              <v-icon>location_city</v-icon>
            </v-list-item-icon>
          </v-list-item>
          <v-list-item v-if="isTechnicalAdmin" @click.stop="title = 'Users'" to="/administration/people">
            <v-list-item-title>Users</v-list-item-title>
            <v-list-item-icon>
              <v-icon>people</v-icon>
            </v-list-item-icon>
          </v-list-item>
        </v-list-group>
        <v-list-group v-if="isTechnicalAdmin" no-action prepend-icon="settings_ethernet">
          <v-list-item slot="activator">
            <v-list-item-title>Profiles</v-list-item-title>
          </v-list-item>
          <v-list-item
            v-for="item in profiles"
            :key="item.title"
            @click.stop="title = item.title"
            :to="item.path == '#' ? '' : item.path"
          >
            <v-list-item-title v-text="item.title"></v-list-item-title>
            <v-list-item-icon>
              <v-icon v-text="item.action"></v-icon>
            </v-list-item-icon>
          </v-list-item>
        </v-list-group>
        <v-list-group v-if="isTechnicalAdmin" no-action prepend-icon="settings">
          <v-list-item slot="activator">
            <v-list-item-title>Settings</v-list-item-title>
          </v-list-item>
          <v-list-item
            v-for="item in settings"
            :key="item.title"
            @click.stop="title = item.title"
            :to="item.path == '#' ? '' : item.path"
          >
            <v-list-item-title v-text="item.title"></v-list-item-title>
            <v-list-item-icon>
              <v-icon v-text="item.action"></v-icon>
            </v-list-item-icon>
          </v-list-item>
        </v-list-group>
        <v-list-item @click.stop="$msal.signOut()">
          <v-list-item-icon>
            <v-icon>exit_to_app</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Sign out</v-list-item-title>
        </v-list-item>
        <v-divider></v-divider>
        <v-list-item>
          <v-list-item-title class="text-right font-weight-thin">Roles: {{myRoles}} - v{{version}}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
    <v-app-bar fixed app dark color="primary" class="no-print">
      <v-toolbar-title>{{ title }}</v-toolbar-title>
    </v-app-bar>
    <v-content>
      <v-container>
        <v-row v-if="user && user.profile && me && me.person">
          <v-col cols="12" lg="12">
            <v-dialog 
              v-model="errorDialog"
              outlined
              max-width="500">
              <v-card dark color="error">
                <v-card-title>Error</v-card-title>
                <v-card-text>
                  <v-row>
                    <v-col cols="12">Something went wrong. Please try again or contact the administrator.</v-col>
                    <v-col cols="12">Code: {{errorDialogCode}}</v-col>
                    <v-col v-if="isTechnicalAdmin" cols="12">Details: {{errorDialogMessage}}</v-col>
                  </v-row>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn text @click="errorDialogCode=''">close</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
            <router-view v-if="(isTechnicalAdmin || me.person.isOrganizationAdmin || me.person.isUserAdmin ||  me.person.isEditor || me.person.isValidator)" :me="me"></router-view>
            <v-row v-else>
              <v-col cols="12">U heeft nog geen toegang tot de functies van ID Flow. Neem contact op met uw beheerder.</v-col>
              <v-col cols="12">You're account has not yet been configured to access the ID Flow functionality. Please contact your administrator.</v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row v-if="!user || !user.profile || !me">
          <v-col cols="12">
            {{getMeResult}}
          </v-col>
        </v-row>
      </v-container>
    </v-content>
  </v-app>
</template>
<style scoped>
.v-list__tile--active {
  color: lime;
}
</style>
<style>
@media screen {
}
@media print {
  * {
    color: black;
  }
  div[role="listitem"] {
    border-bottom: 1px solid black !important;
  }
  div[role="listitem"].primary {
    border-top: 2px solid black !important;
    background-color: black !important;
    font-weight: bold !important;
    color: white !important;
  }
  .no-print {
    display: none;
  }
  button {
    display: none !important;
  }
  .v-content {
    padding: 0 !important;
  }
  table th + th {
    border-left: 1px solid #dddddd;
    border-bottom: 1px solid #dddddd;
  }
  table td + td {
    border-left: 1px solid #dddddd;
    border-bottom: 1px solid #dddddd;
  }

  .dense-row {
    padding: 0;
  }
}
</style>

<script>
import router from "./router";
export default {
  name: "App",
  data() {
    return {
      errorDialog: false,
      errorDialogCode: "",
      errorDialogMessage: "",
      title: "ID Flow",
      getMeResult: "Loading data..",
      drawer: true,
      profiles: [
        {
          title: "Organizations",
          path: "/profiles/organization",
          action: "location_city"
        },
        { 
          title: "Assets", 
          path: "/profiles/asset", 
          action: "style" 
        },
        {
          title: "Identities",
          path: "/profiles/identity",
          action: "people_outline"
        },
        {
          title: "Document Types",
          path: "/profiles/documenttype",
          action: "documents"
        }
      ],
      settings: [
        { title: "Counters", path: "/settings/counters", action: "mdi-notebook" },
        { title: "System log", path: "/settings/systemlog", action: "mdi-notebook" }
      ],
      profilePhoto: null,
      graphToken: null,
      me: null,
      identityStatuses: null,
      sexes: [
        {value: 0, name:'Unknown' },
        {value: 1, name:'Male' },
        {value: 2, name:'Female' },
        {value: 3, name:'Unspecified' }
      ],
    };
  },
  watch: {
    "$msal.data.graph.photo": {
      handler(value) {
        if (value) this.setProfilePhoto(value);
      },
      immediate: true
    },
    errorDialogCode(val) {
      val ? this.errorDialog = true : this.errorDialog = false;
    }
  },
  computed: {
    version() {
      return this.$version;
    },
    myName() {
      var result = this.user.name;
      if (this.me && this.me.person) result = this.me.person.firstname + (this.me.person.surnamePrefix ? ' ' + this.me.person.surnamePrefix : '') + ' ' + this.me.person.surname;
      return result;
    },
    myRoles() {
      if (this.isTechnicalAdmin || 
        (this.me && this.me.person && this.me.person.isOrganizationAdmin) || 
        (this.me && this.me.person && this.me.person.isUserAdmin) || 
        (this.me && this.me.person && this.me.person.isEditor) || 
        (this.me && this.me.person && this.me.person.isValidator)) {
          return (this.isTechnicalAdmin ? 'T' : '') + 
            (this.me && this.me.person && this.me.person.isOrganizationAdmin ? 'O' : '') + 
            (this.me && this.me.person && this.me.person.isUserAdmin ? 'A' : '') + 
            (this.me && this.me.person && this.me.person.isEditor ? 'E' : '') + 
            (this.me && this.me.person && this.me.person.isValidator ? 'V' : '')
      } else {
      return "U";
      }
    },
    isTechnicalAdmin() {
      if (!this.$msal.data.user.idToken.roles) return false;
      return this.$msal.data.user.idToken.roles.includes("Admin");
    },
    user() {
      let user = null;
      if (this.$msal.isAuthenticated()) {
        user = {
          ...this.$msal.data.user,
          profile: {}
        };
        if (this.$msal.data.graph && this.$msal.data.graph.profile) {
          user.profile = this.$msal.data.graph.profile;
        }
      }
      return user;
    }
  },
  methods: {
    setProfilePhoto(photo) {
      var urlCreator = window.URL || window.webkitURL;
      var imageUrl = urlCreator.createObjectURL(photo);
      this.profilePhoto = imageUrl;
    },
    getMe() {
      this.$http
        .get("api/identities/me")
        .then(request => {
          if (request.status == 200) {
            this.me = request.data;
          }
        })
        .catch(e => {
          this.getMeResult = "There was an error loading the application data. Please contact the administrator."
          this.$root.$children[0].$emit("display-error", "1100", e);
          router.push({name: "SignIn"});
        });
    },
    getIdentityStatuses() {
      this.$http
        .get("api/identities/statuses")
        .then(request => {
          this.identityStatuses = request.data;
        })
        .catch(e => {
          this.$root.$children[0].$emit("display-error", "1101", e);
        });
    },
    getTriggerName(triggerIndex) {
      var myName = this.triggerNames.find(x => x.ti == triggerIndex);
      return myName ? myName.name : "";
    },
    getIdentityStatusId(name) {
      if (!name) return -1;
      return this.identityStatuses.find(x => x.name.toLowerCase() == name.toLowerCase()).id;
    },
    getIdentityStatusName(id, nl) {
      var name = this.identityStatuses.find(x => x.id == id).name;
      if (nl) {
          if (name == "Created") return "Start";
          if (name == "Incomplete") return "Niet compleet";
          if (name == "Validation") return "Beoordeling";
          if (name == "Announced") return "Aangekondigd";
          if (name == "Active") return "Actief";
          if (name == "Revoked") return "Ingetrokken";
          if (name == "Expired") return "Verlopen";
          if (name == "Deleted") return "Verwijderd";
      } else {
          return name;
      }
    },
    getSexesId(name) {
      if (!name) return -1;
      return this.sexes.find(x => x.name.toLowerCase() == name.toLowerCase()).value;
    },
    getSexesName(id, nl) {
      if (!id) id = 0;
      if (!Number.isInteger(id)) id = parseInt(id);
      var name = this.sexes.find(x => x.value == id).name;
      if (nl) {
          if (name == "Unknown") return "Onbekend / Unknown";
          if (name == "Male") return "Man / Male";
          if (name == "Female") return "Vrouw / Female";
          if (name == "Unspecified") return "Niet vastgesteld / Unspecified";
       } else{
          return name;
      }
    }
  },
  mounted() {
    this.$on('display-error', (code, msg) => {
      this.errorDialogMessage = msg;
      this.errorDialogCode = code;
    });
    if (this.$msal.isAuthenticated()) {
      this.getMe();
      this.getIdentityStatuses();
    }
  }
};
</script>